import _get from 'lodash/get'
import React from 'react'
import { Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/SvgIcon'
import { body1, body2 } from '@ui-kit/core/typography'

import { stepper } from './styles'
import type { Props } from './types'

const Stepper = (props: Props) => {
  const { progressIndicatorContainer, progressIndicator, progressLine, textContainer } = stepper()

  const checkmarkIcon = IMAGE.icons.xsmall.checkmarkWhite_14x11
  const checkmarkIconSrc = checkmarkIcon.default?.src ?? checkmarkIcon

  return (
    <View>
      {props.steps.map((step, index, items) => {
        const isCurrentActiveStep = step.status === 'active'
        const isPastStep = step.status === 'completed'
        const isPendingStep = step.status === 'pending'
        const isLastStep = index === items.length - 1

        return (
          <View key={`step${index}`} className="flex-row">
            <View className={progressIndicatorContainer()}>
              <View
                className={progressIndicator({
                  pastStep: isPastStep,
                  currentStep: isCurrentActiveStep,
                  pendingStep: isPendingStep,
                })}
              >
                {isPastStep ? (
                  <Icon imgSrc={checkmarkIconSrc} />
                ) : (
                  <Text className={body2({ color: 'black' })}>{index + 1}</Text>
                )}
              </View>
              <View
                className={progressLine({
                  pastStep: isPastStep,
                  pendingStep: isPendingStep,
                  lastStep: isLastStep,
                })}
              />
            </View>
            <View className={textContainer({ lastStep: isLastStep })}>
              <View>
                <Text className={body1({ bold: true })}>{step.title}</Text>
              </View>
              {step.subtitle && !isPastStep ? (
                <View className="mt-1">
                  <Text className={body2({ color: 'uiDarkDisabled' })}>{step.subtitle}</Text>
                </View>
              ) : null}
              {!isPastStep ? (
                <View className="mt-2">
                  <Text className={body2({ color: 'grey700' })}>{step.description}</Text>
                </View>
              ) : null}
            </View>
          </View>
        )
      })}
    </View>
  )
}

export default Stepper
